import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import QuoteImage from '@/assets/quote.svg';

export const Wrapper = styled('div')(({ theme }) => ({
  height: 416,
  display: 'flex',
  backgroundColor: theme.palette.common.white,
  justifyContent: 'center',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.grayscale[300]}`,
  borderRadius: 4,
  padding: theme.spacing(3.5),
  position: 'relative',

  [theme.breakpoints.down(360)]: {
    padding: theme.spacing(2),
  },
}));

export const MainPhoto = styled('div')(({ theme }) => ({
  width: 120,
  height: 120,
  margin: 'auto',
  backgroundColor: theme.palette.grayscale[300],
  position: 'relative',

  img: {
    borderRadius: 4,
    objectFit: 'cover',
  },
}));

export const Quote = styled(QuoteImage)(() => ({
  position: 'absolute',
  top: 148,
  left: 37,
  width: 24,
  heigth: 24,
}));

export const Content = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(4),
  textAlign: 'center',
  height: 152,
  position: 'relative',
  overflow: 'hidden',

  '&:after': {
    content: '""',
    border: `1px solid #d5d5d552`,
    position: 'absolute',
    width: 230,
    bottom: 0,
    left: 20,
    zIndex: -1,
  },
}));

export const TileText = styled(Typography)(() => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: '6',
  whiteSpace: 'pre-wrap',
  overflow: 'hidden',
  display: '-webkit-box',
}));
